/**
 * @owner @Appboy/push
 */

// generated from 744 samples

import { z } from "zod";
import { common } from "../common";
import { clickActionSchema } from "../shared/clickActionSchema";
import { messageGetBaseSchema } from "./messageGetBaseSchema";

export const kindlePushMessageGetSchema = z.object({
  ...messageGetBaseSchema.shape,
  message_type: z.literal("kindlePush"),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 678 (100.00%) in sample data, but Ruby type is String
  kindle_category: z.string().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 678 (100.00%) in sample data, but Ruby type is String
  kindle_collapse_key: z.string().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 496 (73.16%)
  kindle_custom_uri: z.string().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 472 (69.62%)
  kindle_extras: z.record(z.string(), z.string()).nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // true 78 (11.50%), false 600 (88.50%)
  kindle_only_most_recent_device: z.boolean().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 9 (1.33%)
  // avg: -0.01, min: -2, max: 2
  kindle_priority: z.int().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  kindle_push_buttons: z
    .array(
      z.object({
        // Canonical values from shared_constants.json FLEXIBLE_ON_CLICK
        action_type: clickActionSchema,
        human_readable: z.string(),
        id: common.objectId,
        marked_as_deleted: z.boolean(),
        text: z.string().nullable(),
        uri: z.string().nullable(),
        use_webview: z.boolean().nullable().optional(),
      })
    )
    .nullable()
    .optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 3 (0.44%)
  kindle_push_message: z.string().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 650 (95.87%)
  kindle_sound: z.string().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 614 (90.56%)
  kindle_summary_text: z.string().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 678 (100.00%) in sample data, but Ruby type is String
  kindle_summary_text_big: z.string().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 49 (7.23%)
  // avg: 1864354.11, min: -2, max: 2937600
  kindle_time_to_live: z.int().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 3 (0.44%)
  kindle_title: z.string().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 678 (100.00%) in sample data, but Ruby type is String
  kindle_title_big: z.string().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 7 (1.03%)
  kindle_uri_type: clickActionSchema.nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 44 (6.49%)
  // true 621 (97.95%), false 13 (2.05%)
  kindle_use_webview: z.boolean().nullable().optional(),
  // undefined: 66 (8.87%), defined 678 (91.13%)
  // null: 678 (100.00%) in sample data, but Ruby type is Integer
  kindle_visibility: z.int().nullable().optional(),
  // avg: 753732658.21, min: 0, max: 1749500654
  last_sent_kindle_push: z.int().min(0).nullable().optional(),
});
